import { gql } from "@apollo/client";

export const JOIN_CALL_MUTATION = gql`
  mutation JoinVideoCall($input: JoinVideoCallInput!) {
    joinVideoCall(input: $input) {
      success
      message
      data
    }
  }
`;
